export let ServerPath = (path, prepend = "") => {
    let sp = Array.isArray(path) ? (path.length > 0 ? path.join(":") : "") : path;
    //  console.log("ServerPath", path, sp);
    return sp + prepend;
};
